// extracted by mini-css-extract-plugin
export default {"root":"PlasmicContinueButton_root__Mmnes","text":"PlasmicContinueButton_text__s30+l"};